<template>
  <div class="rental-place-detail-page overview-page" style="margin-top: 8px">
    <EntityOverviewLayout v-if="rentalPlace">
      <template #top-left>
        <RentalPlaceDetails :rentalPlace="rentalPlace" @update="updateRentalPlace" />
      </template>

      <template #top-right>
        <RentalPlaceInstruments :key="rentalPlace.id" :rentalPlaceId="rentalPlace.id" />
      </template>
    </EntityOverviewLayout>
  </div>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import { API_ENDPOINTS } from '@/services/config';
import EntityOverviewLayout from '@/components/EntityOverviewLayout.vue';
import RentalPlaceDetails from '@/components/RentalPlaceDetails.vue';
import RentalPlaceInstruments from '@/components/RentalPlaceInstruments.vue';

export default {
  name: 'RentalPlaceDetailPage',
  components: {
    EntityOverviewLayout,
    RentalPlaceDetails,
    RentalPlaceInstruments,
  },
  setup() {
    return { toast: useToast() };
  },
  data() {
    return {
      rentalPlace: null,
    };
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(id) {
        if (id) this.fetchRentalPlace();
      },
    },
  },
  methods: {
    async fetchRentalPlace() {
      try {
        const response = await axios.get(API_ENDPOINTS.rentalPlace(this.$route.params.id));
        this.rentalPlace = response.data;
      } catch (error) {
        this.toast.error(error?.response?.status === 404 ? 'Support expense not found' : 'Failed to fetch support expense');
        console.error('Failed to fetch rental place:', error);
      }
    },
    async updateRentalPlace(changes) {
      try {
        await axios.put(API_ENDPOINTS.rentalPlace(this.rentalPlace.id), changes, {
          headers: { 'Content-Type': 'application/json' },
        });
        this.toast.success('Support expense updated');
        await this.fetchRentalPlace();
      } catch (error) {
        this.toast.error(error?.response?.data?.message || 'Failed to update support expense');
        console.error('Failed to update rental place:', error);
      }
    },
  },
};
</script>
